import { createContext, useContext } from 'react';

export type BricksDialogContextValue = {
  scope: string;
};

export const BricksDialogContext = createContext<BricksDialogContextValue | null>(null);

export const useBricksDialogContext = () => useContext(BricksDialogContext);
